<template>
	<div class="card">
		<div class="card-header">
			<span class="fs-5">Data Izin Presensi</span>
		</div>
		<div class="card-body p-0" v-loading="loading">
			<el-tabs v-model="activeTab" type="border-card" @tab-click="handleTabClick" :before-leave="beforeLeaveTab" class="rounded-bottom border-0">
				<el-tab-pane label="Guru" name="izin-guru" />
				<el-tab-pane label="Tenaga Kependidikan" name="izin-karyawan" />
				<el-tab-pane label="Siswa" name="izin-siswa" />
				<el-tab-pane label="Non-GTK" name="izin-non-gtk" />
				<router-view
					:update-editing="updateEditing"
					:is-petugas-presensi="isPetugasPresensi"
					:jenis-masuk-pulang="jenisMasukPulang"
					:jenis-penuh="jenisPenuh"
					v-slot="{ Component }">
					<transition name="fade" mode="out-in">
						<div v-if="routeName === 'izin'" class="row g-3">
							<div class="text-center" v-if="loading">Memuat...</div>
							<div class="text-center" v-else-if="izinPresensi.length === 0">Data tidak ditemukan</div>
							<div v-for="ip in izinPresensi" :key="ip.type" class="col-12 col-sm-6 col-md-4 col-lg-3" v-else>
								<div class="card">
									<div class="card-header small">
										{{ userTypes[ip.type]?.label || "lainnya" }}
										<router-link :to="{ name: userTypes[ip.type]?.name || 'izin' }">
											<el-icon><i class="bi bi-box-arrow-in-up-right"></i></el-icon>
										</router-link>
									</div>
									<div class="card-body">
										<div class="d-flex gap-1 align-items-baseline">
											<transition name="slide-up" mode="out-in">
												<span class="fs-5" :key="ip.jumlah">
													{{ ip.jumlah }}
												</span>
											</transition>
											data
										</div>
									</div>
								</div>
							</div>
						</div>
						<component :is="Component" v-else />
					</transition>
				</router-view>
			</el-tabs>
		</div>
	</div>
</template>

<script>
export default {
	name: "IzinView",
	data() {
		return {
			izinPresensi: [],
			userTypes: {
				guru: { label: "Guru", name: "izin-guru" },
				karyawan: { label: "Tenaga Kependidikan", name: "izin-karyawan" },
				non_gtk: { label: "Non-GTK", name: "izin-non-gtk" },
				siswa: { label: "Siswa", name: "izin-siswa" },
			},
			jenisMasukPulang: ["Sakit", "Izin Dinas", "Izin Pribadi"],
			jenisPenuh: ["Sakit", "Izin Dinas", "Izin Pribadi", "Cuti", "Dispensasi"],
			loading: true,
			activeTab: "",
			isEditing: false,
		};
	},
	computed: {
		isPetugasPresensi() {
			const roles = this.$store.getters.getRoles;
			return roles?.some((r) => ["dev", "presensi"].includes(r.role));
		},
		routeName() {
			return this.$route.name;
		},
	},
	watch: {
		routeName: {
			immediate: true,
			handler(val) {
				if (val !== "izin") this.loading = false;

				this.activeTab = val;
			},
		},
	},
	mounted() {
		window.addEventListener("beforeunload", this.handleBeforeUnload);
		this.$ws.main.on("izin:inserted", this.insertedIzin);
		this.$ws.main.on("izin:deleted", this.deletedIzin);
		this.getJumlahIzinPresensi();
	},
	beforeUnmount() {
		window.removeEventListener("beforeunload", this.handleBeforeUnload);
		this.$ws.main.off("izin:inserted");
		this.$ws.main.off("izin:deleted");
	},
	methods: {
		insertedIzin(data) {
			const d = JSON.parse(data);

			const idx = this.izinPresensi.findIndex((up) => up.type === d.type);

			if (idx !== -1) {
				this.izinPresensi[idx] = {
					...this.izinPresensi[idx],
					jumlah: this.izinPresensi[idx].jumlah + 1,
				};
				return;
			}
		},
		deletedIzin(data) {
			const d = JSON.parse(data);

			const idx = this.izinPresensi.findIndex((up) => up.type === d.type);

			if (idx !== -1) {
				this.izinPresensi[idx] = {
					...this.izinPresensi[idx],
					jumlah: this.izinPresensi[idx].jumlah - 1,
				};
				return;
			}
		},
		updateEditing(val) {
			this.isEditing = val;
		},
		handleTabClick(val) {
			this.$router.push({ name: val.paneName });
		},
		beforeLeaveTab() {
			return new Promise((resolve, reject) => {
				if (this.isEditing) {
					reject();
				}
				resolve();
			});
		},
		handleBeforeUnload(e) {
			if (this.isEditing) {
				e.preventDefault();
				e.returnValue = "";
				return "";
			}
		},
		async getJumlahIzinPresensi() {
			try {
				const { data } = await this.$defaultApi.post("/izin/count/user-type");

				await new Promise((resolve) => setTimeout(resolve, 500));
				this.izinPresensi = data.izin_counts;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.error(error);
			} finally {
				this.loading = false;
			}
		},
	},
};
</script>

<style scoped></style>
